"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBoxMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Adornment = require("../../components/Adornment/Adornment.styles");
var _Icon = require("../../components/Icon/Icon.styles");
var _Input = require("../../components/Input/Input.styles");
var _mediaBreakpointMixin = require("../mediaBreakpointMixin");
var _sizeMixin = require("../sizeMixin");
var _spaceMixin = require("../spaceMixin");
var _typographyMixin = require("../typographyMixin");
var largeCSS = function largeCSS(props) {
  return (0, _styledToken.default)('SearchBox.large.paddingLeft', function (paddingLeft) {
    return (0, _styledComponents.css)(["> ", "{padding-left:", ";}"], _Input.StyledInput, paddingLeft ? paddingLeft + "px" : (0, _spaceMixin.spaceMixin)('md')(props));
  })(props);
};
var searchBoxCSS = function searchBoxCSS(large) {
  return function (props) {
    return (0, _styledToken.default)({
      borderWidth: 'Input.borderWidth',
      boxShadow: 'SearchBox.boxShadow',
      fontType: 'SearchBox.fontType',
      height: large ? 'SearchBox.heightLarge' : 'SearchBox.height',
      iconColor: 'SearchBox.iconColor',
      iconSize: large ? 'SearchBox.iconSizeLarge' : 'SearchBox.iconSize'
    }, function (_ref) {
      var borderWidth = _ref.borderWidth,
        boxShadow = _ref.boxShadow,
        fontType = _ref.fontType,
        height = _ref.height,
        iconColor = _ref.iconColor,
        iconSize = _ref.iconSize;
      return (0, _styledComponents.css)(["box-shadow:", ";> ", ",> ", "{", " ", "}", "{color:", ";height:", "px;width:", "px;}", ";"], boxShadow, _Input.StyledInput, _Adornment.StyledAdornment, (0, _typographyMixin.typographyMixin)(Object.assign({
        fontType: fontType,
        fontTypeIconAlignment: false
      }, props)), (0, _sizeMixin.sizeMixin)({
        fontType: fontType,
        borderWidth: borderWidth * 2,
        size: height
      })(props), _Icon.StyledIcon, iconColor, iconSize, iconSize, large ? largeCSS(props) : '');
    })(props);
  };
};

/** @class SearchBoxMixin */
/** @method */
var SearchBoxMixin = function SearchBoxMixin(props) {
  return [searchBoxCSS(false)(props), (0, _styledComponents.css)(["@media ", "{", "}"], (0, _mediaBreakpointMixin.mediaBreakpointMixin)('md')(props), searchBoxCSS(true)(props))];
};
exports.SearchBoxMixin = SearchBoxMixin;